export default "__VITE_ASSET__BXlVL7FB__"